import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from '@app/core/404/page-not-found.component';
import { PageAccueilComponent } from '@app/core/accueil/accueil.component';

import { AuthzGuard } from '@pcscol-portail/ng-authz';
import { structureRouteResolver } from './core/initializer/structure-route.resolver';
import { autorisationGuard } from './shared/autorisations/autorisations.guard';
import { Traitement } from './shared/autorisations/traitements';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('@app-shared/auth/auth-wrapper.module').then(m => m.AuthWrapperModule)
    },
    {
        path: '',
        canActivate: [AuthzGuard],
        data: {
            doc: ''
        },
        children: [
            {
                path: '',
                redirectTo: '/accueil',
                pathMatch: 'full'
            },
            {
                path: 'accueil',
                component: PageAccueilComponent
            },
            {
                path: ':structure',
                canActivate: [AuthzGuard],
                resolve: { structure: structureRouteResolver },
                children: [
                    {
                        path: '',
                        redirectTo: 'editeur',
                        pathMatch: 'prefix'
                    },
                    {
                        path: 'objets-maquette/editeur',
                        data: {
                            title: 'Editeur | ODF | Pégase',
                            doc: 'editeur',
                            showEspaceSelected: true
                        },
                        loadChildren: () => import('@app/features/editeur/editeur.module').then(m => m.EditeurModule)
                    },
                    {
                        path: 'objets-maquette/importer',
                        data: {
                            title: 'Importer | ODF | Pégase',
                            doc: 'importer',
                            showEspaceSelected: true
                        },
                        canActivateChild: [autorisationGuard(Traitement.ODF_IMPORTER_MAQUETTE_BASE64_VERS_ESPACE)],
                        loadChildren: () => import('@app/features/importer/importer.module').then(m => m.ImporterModule)
                    },
                    {
                        path: 'espaces',
                        data: {
                            title: 'Espaces de travail | ODF | Pégase',
                            doc: 'espaces'
                        },
                        loadChildren: () => import('./features/espaces/espaces.module').then(m => m.EspacesModule)
                    },
                    {
                        path: 'annee',
                        data: {
                            title: 'Année universitaire | ODF | Pégase',
                            doc: 'annee'
                        },
                        loadChildren: () => import('./features/annee/annee-universitaire.module').then(m => m.AnneeUniversitaireModule)
                    },
                    {
                        path: 'objets-maquette',
                        data: {
                            title: 'Objets Maquette | ODF | Pégase',
                            doc: 'objets-maquette',
                            showEspaceSelected: true
                        },
                        loadChildren: () => import('@app/features/objets-maquette/objets-maquette.module').then(m => m.ObjetsMaquetteModule)
                    },
                    {
                        path: 'diplomes',
                        data: {
                            title: 'Diplômes | ODF | Pégase',
                            doc: 'diplomes',
                            showEspaceSelected: true
                        },
                        canActivateChild: [autorisationGuard(Traitement.ODF_LIRE_DIPLOME)],
                        loadChildren: () => import('@app/features/diplomes/diplomes.module').then(m => m.DiplomesModule)
                    }
                ]
            },
            {
                path: '**',
                component: PageNotFoundComponent
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: PreloadAllModules,
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            // paramsInheritanceStrategy: inherit route data, see https://stackoverflow.com/a/50780702
            paramsInheritanceStrategy: 'always'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
